import styled from 'styled-components';
import { ShowTransparentVerticalScrollbar, ShowVerticalScrollbar } from '../../global/commonStyle';

const MainDiv = styled.div<{ dropUp?: boolean }>`
  position: ${(props) => (props.dropUp ? 'relative' : '')};
`;

const TimePickerWrapper = styled.div`
  width: 100%;
  position: relative;
  .angleDown-icon {
    transition: transform var(--transition-normal) ease;
  }
  .angleDown-icon.rotate {
    transform: rotate(180deg);
  }
`;

const DropdownWrapper = styled.div<{ isOpen: boolean; dropUp?: boolean }>`
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
  position: absolute;
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-6);
  box-shadow: var(--shadow-dropdown);
  z-index: var(--z-index-modal);
  margin-top: ${(props) => (props.dropUp ? 'unset' : 'var(--space-4)')};
  bottom: ${(props) => (props.dropUp ? '100%' : 'unset')};
  margin-bottom: ${(props) => (props.dropUp ? 'var(--space-4)' : 'unset')};
`;

const TimeColumns = styled.div`
  display: flex;
  height: 200px;
`;

const Column = styled.div`
  width: 60px;
  ${ShowTransparentVerticalScrollbar}
  padding-top: var(--space-8);
  border-left: 0.5px solid var(--border-primary);
  margin-right: var(--space-4);
  &:first-child {
    border-left: none;
  }
  &:hover {
    ${ShowVerticalScrollbar}
  }
`;

const TimeOption = styled.div<{ selected?: boolean }>`
  padding: var(--space-5);
  text-align: center;
  margin-inline: var(--space-6);
  cursor: pointer;
  border-radius: var(--border-radius-4);
  background: ${(props) => (props.selected ? 'var(--neutral-secondary)' : 'transparent')};
  color: var(--text-primary);
  &:hover {
    background: ${(props) => (props.selected ? 'var(--neutral-secondary)' : ' var(--neutral-secondary)')};
  }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: var(--space-12) var(--space-10) var(--space-7);
  border-top: 0.5px solid var(--border-primary);
`;

export { MainDiv, TimePickerWrapper, DropdownWrapper, TimeColumns, Column, TimeOption, ButtonRow };
